























































































































import { Component, Vue, Prop } from 'vue-property-decorator'
import { TipoUsuarioEnum } from '@/types/_'

@Component
export default class ComponentFinxLayout extends Vue {
  @Prop({ required: false, default: 'Título da página' }) pageTitle: string

  tipoUsuario: TipoUsuarioEnum = TipoUsuarioEnum.Hospital

  getWindowWidth() {
    const doc: Document = document

    if (doc !== null) {
      const documentWidth = doc.documentElement.clientWidth
      const navigationDrawerOpen = (doc.querySelector('.v-navigation-drawer--open') as HTMLElement)
      const navigationDrawerMini = (doc.querySelector('.v-navigation-drawer--mini-variant') as HTMLElement)
      const backofficeContainer = (doc.getElementById('backoffice__container') as HTMLDivElement)

      if (backofficeContainer !== null) {
        if (!!navigationDrawerOpen && !!navigationDrawerMini) {
          backofficeContainer.style.width = `${documentWidth - parseInt(navigationDrawerMini.style.width, 10) - 30}px`
          // @ts-ignore
        } else if ((!!navigationDrawerOpen === true) && (!!navigationDrawerMini === false)) {
          backofficeContainer.style.width = `${documentWidth - parseInt(navigationDrawerOpen.style.width, 10) - 30}px`
        } else {
          backofficeContainer.style.width = `${documentWidth - 30}px`
        }
      }
    }
  }

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }

  updated() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.getWindowWidth)
      this.getWindowWidth()
    })
  }
}
